<template>
    <div class="mt-16 xl:mt-0">
        <div class="flex justify-between items-center">
            <h1 class="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white">إضافة جنسية</h1>
        </div>

        <div class="py-2 align-middle inline-block min-w-full mt-6">
         
            <errormessage :error="errors"></errormessage>
            <form
                @submit.prevent="addNationality"
                class="bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 py-6 px-4  sm:p-6 shadow border dark:border-slate-800  sm:rounded-md sm:overflow-hidden"
            >
                <div class="grid md:grid-cols-3 gap-8">

                    <div class="input" :class="{ invalid: $v.nationality.name_ar.$error }">
                        <label for="nationality_name_ar" class="block text-sm font-medium ">
                            الاسم
                        </label>
                        <input
                            type="text"
                            id="nationality_name_ar"
                            placeholder="أكتب الاسم."
                            v-model="nationality.name_ar"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            @blur="$v.nationality.name_ar.$touch()"
                        />
                        <p v-if="!$v.nationality.name_ar.minLength" class="text-xs text-red-500 mt-2">
                            يجب أن يحتوي الاسم على
                            {{ $v.nationality.name_ar.$params.minLength.min }} أحرف على
                            الأقل.
                        </p>
                    </div>

                    <div class="input" :class="{ invalid: $v.nationality.name_en.$error }">
                        <label for="nationality_name_en" class="block text-sm font-medium ">
                            الاسم بالانجليزي
                        </label>
                        <input
                            type="text"
                            id="nationality_name_en"
                            placeholder="أكتب الاسم."
                            v-model="nationality.name_en"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            @blur="$v.nationality.name_en.$touch()"
                        />
                        <p v-if="!$v.nationality.name_en.minLength" class="text-xs text-red-500 mt-2">
                            يجب أن يحتوي الاسم على
                            {{ $v.nationality.name_en.$params.minLength.min }} أحرف على
                            الأقل.
                        </p>
                    </div>

                    <div class="input" :class="{ invalid: $v.nationality.pin_code.$error }">
                        <label for="nationality_pin_code" class="block text-sm font-medium ">
                            رمز PIN
                        </label>
                        <input
                            type="text"
                            id="nationality_pin_code"
                            placeholder="أكتب رمز PIN."
                            v-model="nationality.pin_code"
                            class="mt-1 block w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            @blur="$v.nationality.pin_code.$touch()"
                        />
                        <p v-if="!$v.nationality.pin_code.minLength" class="text-xs text-red-500 mt-2">
                            يجب أن يحتوي الاسم على
                            {{ $v.nationality.pin_code.$params.minLength.min }} أحرف على
                            الأقل.
                        </p>
                    </div>
       
                </div>

                <div class="text-white w-full md:w-auto flex md:justify-end mt-8">
                    <div class="inline w-full md:w-auto" :class=" $v.$invalid ? 'cursor-not-allowed' : 'cursor-pointer' ">
                        <button
                            :disabled="$v.$invalid"
                            type="submit"
                            class="border border-transparent rounded-md shadow-sm w-full md:w-auto py-2 px-16 inline-flex justify-center text-sm font-medium focus:outline-none"
                            :class=" $v.$invalid ? 'bg-gray-600' : 'bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'">
                            إضافة
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import errormessage from "@/components/ErrorMessage"
import { required, minLength } from "vuelidate/lib/validators";
import NationalitiesService from "@/services/NationalitiesService";

export default {
    components: {
        errormessage
    },
    data() {
        return {
            errors: null,
            nationality: {
                name_ar : '',
                name_en : '',
                pin_code : '',
            },
            // loader: "dots",
        };
    },
    created() {
    },
    validations: {
        nationality: {
            name_ar: {
                required,
                minLength: minLength(3),
            },

            name_en: {
                required,
                minLength: minLength(3),
            },

            pin_code: {
                required,
                minLength: minLength(3),
            },
        },
    },
    methods: {
       
        addNationality() {
            let loader = this.$loading.show({
                loader: this.loader,
            });

            let data = {
                name_ar : this.nationality.name_ar,
                name_en : this.nationality.name_en,
                pin_code : this.nationality.pin_code,
            }

            NationalitiesService.createNationality(data)
                .then((resp) => {
                    setTimeout(() => {
                        loader.hide();
                        this.$swal.fire({
                            icon: 'success',
                            text: resp.data.message,
                        })
                        this.$router.push({ name: "nationalities" });
                    }, 10);
                })
                .catch((err) => {
                    loader.hide();

                    this.errors = err.response.data.errors
                    this.$swal.fire({
                        icon: 'error',
                        title: '...عذرا',
                        text: err.response.data.errors.name,
                    })
                });
        },
    },
};
</script>

<style scoped>
.input.invalid label {
    color: red;
}
.input.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
}

[type="submit"],
button {
    cursor: inherit;
    color: inherit;
}
</style>
